import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import EmergencyStrip from "./components/EmergencyStrip";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import PromoVideo from "./components/PromoVideo";
import About from "./components/About";
import HowItWorks from "./components/HowItWorks";
import LocalNetwork from "./components/LocalNetwork";
import AppShowcase from "./components/AppShowcase";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Landing = () => (
  <div className="App bg-white">
    <EmergencyStrip />
    <Navbar />
    <main>
      <Hero />
      <PromoVideo />
      <About />
      <HowItWorks />
      <LocalNetwork />
      <AppShowcase />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
    <Toaster position="top-center" richColors />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
